import { Link } from "react-router-dom";
import { projects } from "@/data/projects";
import { Reveal } from "@/components/Reveal";

export default function Work() {
    return (
        <section id="work" data-testid="work-section" className="mx-auto max-w-[1600px] px-5 py-28 sm:px-10 sm:py-40">
            <Reveal>
                <div className="mb-16 flex items-end justify-between sm:mb-24">
                    <div>
                        <p className="mb-4 font-mono text-[11px] uppercase tracking-[0.35em] text-[#E63946]">
                            Portfolio — 2025/2026
                        </p>
                        <h2 className="font-display text-4xl font-bold uppercase leading-none tracking-tight text-[#F4F4F0] sm:text-6xl lg:text-7xl">
                            Ausgewählte <span className="text-stroke">Arbeiten</span>
                        </h2>
                    </div>
                    <span className="hidden font-mono text-sm text-[#A1A1AA] sm:block">
                        ({String(projects.length).padStart(2, "0")})
                    </span>
                </div>
            </Reveal>

            <div className="grid grid-cols-1 gap-x-10 gap-y-20 md:grid-cols-12 md:gap-y-8">
                {projects.map((p, i) => (
                    <Reveal
                        key={p.slug}
                        delay={0.05}
                        className={i % 2 === 0 ? "md:col-span-7" : "md:col-span-5 md:mt-40"}
                    >
                        <Link
                            to={`/projekt/${p.slug}`}
                            data-testid={`project-card-${p.slug}`}
                            data-cursor="view"
                            className="group block"
                        >
                            <div className="relative aspect-square overflow-hidden bg-[#0D1A14]">
                                <img
                                    src={p.cover}
                                    alt={`${p.name} — ${p.category}`}
                                    loading="lazy"
                                    className="h-full w-full object-contain transition-transform duration-[900ms] ease-out group-hover:scale-[1.04]"
                                />
                                <div className="absolute inset-0 bg-[#132B21]/20 opacity-0 transition-opacity duration-500 group-hover:opacity-100" />
                                <span className="absolute left-4 top-4 font-mono text-[11px] tracking-[0.2em] text-[#F4F4F0]/90">
                                    {String(i + 1).padStart(2, "0")}
                                </span>
                            </div>
                            <div className="mt-5 flex items-start justify-between gap-4 border-t border-white/10 pt-4">
                                <div>
                                    <h3 className="font-display text-xl font-bold uppercase tracking-tight text-[#F4F4F0] transition-colors duration-300 group-hover:text-[#E63946] sm:text-2xl">
                                        {p.name}
                                    </h3>
                                    <p className="mt-1 text-sm text-[#A1A1AA]">{p.category}</p>
                                </div>
                                <span className="font-mono text-xs text-[#A1A1AA]">{p.year}</span>
                            </div>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </section>
    );
}
